<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                :to="$route.query.from === 'table' ? '/program' : `/program/detail/${$route.params.id}`"
                flat
                color="transparent"
                style="width: 20%;">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="28"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="kominfoklaten"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-3"
                    style="font-weight: 600;">
                    Ubah Program
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                min-height="calc(100vh - 245px)"
                style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                <v-card-text
                  class="pt-2">
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <div
                        class="mb-4" v-if="user.role === 'admin'">
                        <v-tabs
                          v-model="form.type_index"
                          dense
                          slider-size="5"
                          :color="set_color">
                          <v-tab
                            v-for="(item, index) in menu"
                            :key="index"
                            @click="form.type = item; form.program_id  = ''; form.kegiatan_id  = ''; form.par_id  = '';">
                            <span
                              class="body-2 font-weight-bold text-capitalize">
                              {{ item }}
                            </span>
                          </v-tab>
                        </v-tabs>
                      </div>

                      <v-row>
                        <v-col
                          cols="12"
                          md="3">
                          <ValidationProvider 
                            name="Tahun Anggaran" 
                            rules="required"
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>
                              
                              Tahun Anggaran
                            </div>

                            <v-select
                              v-on:keyup.enter="save()"

                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Contoh. 2023"
                              

                              hide-details

                              :items="years"
                              :item-color="set_color"

                              @change="form.tahun_anggaran_id = ''; form.status_dpa = ''; form.anggaran_before = 0; fetchProgram(); fetchDpa();"

                              v-model="form.tahun_anggaran"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.tahun_anggaran !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-select>
                          </ValidationProvider>
                        </v-col>

                        <!-- <v-col
                          cols="12"
                          md="9">
                          <ValidationProvider 
                            name="Keterangan Tahun Anggaran" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              Keterangan Tahun Anggaran
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Contoh. Anggaran tahun 2024 untuk penyusunan perencanaan perangkat daerah"

                              hide-details

                              v-model="form.tahun_anggaran_text"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.tahun_anggaran_text !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col> -->
                      </v-row>
                      
                      <v-row v-if="form.type !== 'Program'">
                        <v-col
                          cols="12"
                          md="12">
                          <ValidationProvider 
                            name="Program"
                            rules="required"  
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Program
                            </div>

                            <v-autocomplete
                              v-on:keyup.enter="save()"

                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Contoh. Program Penunjang Urusan"

                              hide-details
                              

                              :items="list.program"
                              item-text="title"
                              item-value="id"
                              :item-color="set_color"

                              @change="form.kegiatan_id  = ''; fetchKegiatan();"

                              v-model="form.program_id"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.program_id !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-autocomplete>
                          </ValidationProvider>
                        </v-col>

                        <v-col v-if="form.type !== 'Program' && form.type !== 'Kegiatan'"
                          cols="12"
                          md="12">
                          <ValidationProvider 
                            name="Kegiatan"
                            rules="required"  
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Kegiatan
                            </div>

                            <v-autocomplete
                              v-on:keyup.enter="save()"

                              filled
                              rounded
                              dense
                              

                              :color="set_color"
                              placeholder="Contoh. Perencanaan, Penganggaran dan Evaluasi"

                              hide-details

                              :items="list.kegiatan"
                              item-text="title"
                              item-value="id"
                              :item-color="set_color"

                              v-model="form.kegiatan_id"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.kegiatan_id !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-autocomplete>
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <!-- <v-col
                          cols="12"
                          md="6">
                          <ValidationProvider 
                            name="Kode" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              Kode
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              
                              :color="set_color"
                              placeholder="Contoh. 1.03.01XXX"
                              
                              hide-details

                              v-model="form.code"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.code !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col> -->

                        <v-col
                          cols="12"
                          md="12">
                          <ValidationProvider 
                            name="Judul" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Judul
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              

                              :color="set_color"
                              placeholder="Contoh. Penyusunan Dokumen Perencanaan Perangkat Daerah"

                              hide-details

                              v-model="form.title"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.title !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <v-row v-if="form.type === 'Sub Kegiatan'">
                        <v-col
                          cols="12"
                          md="6"
                          class="pb-0">
                          <div
                            class="body-2 font-weight-bold black--text">
                            #Anggaran
                          </div>
                        </v-col>
                      </v-row>

                      <v-row v-if="form.anggaran_before > 0 && form.type === 'Sub Kegiatan'">
                        <v-col
                          cols="12"
                          md="12">
                          <v-card
                            flat
                            color="#ff980026"
                            class="pa-3"
                            style="border: 2px dashed orange; border-radius: 10px;">
                            <div
                              class="line-text-second">
                              <div>
                                Nominal anggaran tidak boleh melebihi
                              </div>

                              <div>
                                pagu anggaran "{{ form.type === 'Kegiatan' ? 'Program' : 'Kegiatan' }}" sebesar : <span class="body-1 font-weight-bold black--text">{{ Number(form.anggaran_before) | price }}</span>
                              </div>
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>

                      <v-row v-if="form.type === 'Sub Kegiatan'">
                        <v-col
                          cols="12"
                          md="6">
                          <ValidationProvider
                            name="Nominal Anggaran (RENJA)" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>
                              Nominal Anggaran (RENJA)
                            </div>

                            <v-currency-field
                              filled
                              rounded
                              dense
                              

                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              :min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 120.000.000"

                              hide-details

                              v-model="form.anggaran"
                              :success="form.anggaran !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.anggaran !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="6">
                          <!-- <ValidationProvider
                            name="Nominal Anggaran (PERUBAHAN)" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>
                              Nominal Anggaran (PERUBAHAN)
                            </div>

                            <v-currency-field
                              filled
                              rounded
                              dense

                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              :min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 150.000.000"

                              hide-details

                              v-model="form.anggaran_perubahan"
                              :success="form.anggaran_perubahan !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.anggaran_perubahan !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-currency-field>
                          </ValidationProvider> -->
                        </v-col>
                      </v-row>

                      <div>
                        <v-row v-if="form.type === 'Sub Kegiatan'">
                          <v-col
                            cols="12"
                            md="3"
                            class="pb-2">
                            <v-btn
                              @click="show_anggaran = !show_anggaran ? true : false"
                              block
                              height="40"
                              color="#f0f0f0"
                              elevation="0"
                              class="body-2 font-weight-bold text-capitalize black--text d-flex align-center"
                              style="border-radius: 10px;">
                              <span>
                                #Target Keuangan Bulanan
                              </span>
  
                              <v-spacer />
  
                              <v-icon 
                                color="black">
                                {{ !show_anggaran ? 'mdi-menu-down' : 'mdi-menu-up' }}
                              </v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
  
                        <v-row v-if="form.type === 'Sub Kegiatan' && show_anggaran">
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Januari" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Januari
                              </div>
  
                              <v-currency-field
                                filled
                                rounded
                                dense
  
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                :min="0"
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10.000.000"
  
                                hide-details
                                
  
                                v-model="form.target_keu_1"
                                :success="form.target_keu_1 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.target_keu_1 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Februari" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Februari
                              </div>
  
                              <v-currency-field
                                filled
                                rounded
                                dense
  
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                :min="0"
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10.000.000"
  
                                hide-details
                                
  
                                v-model="form.target_keu_2"
                                :success="form.target_keu_2 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.target_keu_2 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Maret" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Maret
                              </div>
  
                              <v-currency-field
                                filled
                                rounded
                                dense
  
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                :min="0"
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10.000.000"
  
                                hide-details
                                
  
                                v-model="form.target_keu_3"
                                :success="form.target_keu_3 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.target_keu_3 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="April" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                April
                              </div>
  
                              <v-currency-field
                                filled
                                rounded
                                dense
  
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                :min="0"
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10.000.000"
  
                                hide-details
                                
  
                                v-model="form.target_keu_4"
                                :success="form.target_keu_4 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.target_keu_4 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Mei" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Mei
                              </div>
  
                              <v-currency-field
                                filled
                                rounded
                                dense
  
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                :min="0"
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10.000.000"
  
                                hide-details
                                
  
                                v-model="form.target_keu_5"
                                :success="form.target_keu_5 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.target_keu_5 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Juni" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Juni
                              </div>
  
                              <v-currency-field
                                filled
                                rounded
                                dense
  
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                :min="0"
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10.000.000"
  
                                hide-details
                                
  
                                v-model="form.target_keu_6"
                                :success="form.target_keu_6 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.target_keu_6 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Juli" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Juli
                              </div>
  
                              <v-currency-field
                                filled
                                rounded
                                dense
  
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                :min="0"
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10.000.000"
  
                                hide-details
                                
  
                                v-model="form.target_keu_7"
                                :success="form.target_keu_7 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.target_keu_7 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Agustus" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Agustus
                              </div>
  
                              <v-currency-field
                                filled
                                rounded
                                dense
  
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                :min="0"
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10.000.000"
  
                                hide-details
                                
  
                                v-model="form.target_keu_8"
                                :success="form.target_keu_8 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.target_keu_8 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="September" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                September
                              </div>
  
                              <v-currency-field
                                filled
                                rounded
                                dense
  
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                :min="0"
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10.000.000"
  
                                hide-details
                                
  
                                v-model="form.target_keu_9"
                                :success="form.target_keu_9 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.target_keu_9 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Oktober" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Oktober
                              </div>
  
                              <v-currency-field
                                filled
                                rounded
                                dense
  
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                :min="0"
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10.000.000"
  
                                hide-details
                                
  
                                v-model="form.target_keu_10"
                                :success="form.target_keu_10 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.target_keu_10 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="November" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                November
                              </div>
  
                              <v-currency-field
                                filled
                                rounded
                                dense
  
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                :min="0"
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10.000.000"
  
                                hide-details
                                
  
                                v-model="form.target_keu_11"
                                :success="form.target_keu_11 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.target_keu_11 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Desember" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Desember
                              </div>
  
                              <v-currency-field
                                filled
                                rounded
                                dense
  
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                :min="0"
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10.000.000"
  
                                hide-details
                                
  
                                v-model="form.target_keu_12"
                                :success="form.target_keu_12 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.target_keu_12 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
  
                        <v-row v-if="form.type === 'Sub Kegiatan'">
                          <v-col
                            cols="12"
                            md="3"
                            class="mt-1 pb-2">
                            <v-btn
                              @click="show_fisik = !show_fisik ? true : false"
                              block
                              height="40"
                              color="#f0f0f0"
                              elevation="0"
                              class="body-2 font-weight-bold text-capitalize black--text d-flex align-center"
                              style="border-radius: 10px;">
                              <span>
                                #Target Fisik Bulanan
                              </span>
  
                              <v-spacer />
  
                              <v-icon 
                                color="black">
                                {{ !show_fisik ? 'mdi-menu-down' : 'mdi-menu-up' }}
                              </v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
  
                        <v-row v-if="form.type === 'Sub Kegiatan' && show_fisik">
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Januari" 
                              rules="max_100:100"
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Januari
                              </div>
  
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                filled
                                rounded
                                dense
  
                                onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                                type="number"
                                min="0"
                                
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10"
  
                                suffix="%"
  
                                hide-details
  
                                v-model="form.target_fisik_1"
                                :success="form.target_fisik_1 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.target_fisik_1 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Februari" 
                              rules="max_100:100"
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Februari
                              </div>
  
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                filled
                                rounded
                                dense
  
                                onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                                type="number"
                                min="0"
                                
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10"
  
                                suffix="%"
  
                                hide-details
  
                                v-model="form.target_fisik_2"
                                :success="form.target_fisik_2 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.target_fisik_2 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Maret" 
                              rules="max_100:100"
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Maret
                              </div>
  
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                filled
                                rounded
                                dense
  
                                onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                                type="number"
                                min="0"
                                
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10"
  
                                suffix="%"
  
                                hide-details
  
                                v-model="form.target_fisik_3"
                                :success="form.target_fisik_3 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.target_fisik_3 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="April" 
                              rules="max_100:100"
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                April
                              </div>
  
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                filled
                                rounded
                                dense
  
                                onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                                type="number"
                                min="0"
                                
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10"
  
                                suffix="%"
  
                                hide-details
  
                                v-model="form.target_fisik_4"
                                :success="form.target_fisik_4 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.target_fisik_4 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Mei" 
                              rules="max_100:100"
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Mei
                              </div>
  
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                filled
                                rounded
                                dense
  
                                onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                                type="number"
                                min="0"
                                
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10"
  
                                suffix="%"
  
                                hide-details
  
                                v-model="form.target_fisik_5"
                                :success="form.target_fisik_5 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.target_fisik_5 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Juni" 
                              rules="max_100:100"
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Juni
                              </div>
  
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                filled
                                rounded
                                dense
  
                                onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                                type="number"
                                min="0"
                                
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10"
  
                                suffix="%"
  
                                hide-details
  
                                v-model="form.target_fisik_6"
                                :success="form.target_fisik_6 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.target_fisik_6 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Juli" 
                              rules="max_100:100"
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Juli
                              </div>
  
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                filled
                                rounded
                                dense
  
                                onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                                type="number"
                                min="0"
                                
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10"
  
                                suffix="%"
  
                                hide-details
  
                                v-model="form.target_fisik_7"
                                :success="form.target_fisik_7 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.target_fisik_7 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Agustus" 
                              rules="max_100:100"
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Agustus
                              </div>
  
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                filled
                                rounded
                                dense
  
                                onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                                type="number"
                                min="0"
                                
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10"
  
                                suffix="%"
  
                                hide-details
  
                                v-model="form.target_fisik_8"
                                :success="form.target_fisik_8 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.target_fisik_8 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="September" 
                              rules="max_100:100"
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                September
                              </div>
  
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                filled
                                rounded
                                dense
  
                                onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                                type="number"
                                min="0"
                                
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10"
  
                                suffix="%"
  
                                hide-details
  
                                v-model="form.target_fisik_9"
                                :success="form.target_fisik_9 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.target_fisik_9 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Oktober" 
                              rules="max_100:100"
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Oktober
                              </div>
  
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                filled
                                rounded
                                dense
  
                                onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                                type="number"
                                min="0"
                                
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10"
  
                                suffix="%"
  
                                hide-details
  
                                v-model="form.target_fisik_10"
                                :success="form.target_fisik_10 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.target_fisik_10 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="November" 
                              rules="max_100:100"
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                November
                              </div>
  
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                filled
                                rounded
                                dense
  
                                onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                                type="number"
                                min="0"
                                
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10"
  
                                suffix="%"
  
                                hide-details
  
                                v-model="form.target_fisik_11"
                                :success="form.target_fisik_11 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.target_fisik_11 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="3">
                            <ValidationProvider
                              name="Desember" 
                              rules="max_100:100"
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                Desember
                              </div>
  
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                filled
                                rounded
                                dense
  
                                onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                                type="number"
                                min="0"
                                
  
                                @focus="$event.target.select()"
  
                                :color="set_color"
                                placeholder="Contoh. 10"
  
                                suffix="%"
  
                                hide-details
  
                                v-model="form.target_fisik_12"
                                :success="form.target_fisik_12 !== '' && valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
  
                                  <div v-if="form.target_fisik_12 !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                      </div>


                      <v-row v-if="form.type === 'Sub Kegiatan'">
                        <v-col
                          cols="12"
                          md="6"
                          class="pb-0">
                          <div
                            class="body-2 font-weight-bold black--text">
                            #Penanggung Jawab 
                          </div>
                        </v-col>
                      </v-row>

                      <v-row v-if="form.type === 'Sub Kegiatan'">
                        <v-col
                          cols="12"
                          md="6">
                          <ValidationProvider 
                            name="Nama PPKOM" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              Nama PPKOM
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Contoh. Abdul Rozaq, S.T., M.T."

                              hide-details

                              v-model="form.ppkom_name"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.ppkom_name !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="6">
                          <ValidationProvider 
                            name="Nama PPTK" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              Nama PPTK
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Contoh. Joko Marhanto, S.E., M.M."

                              hide-details

                              v-model="form.pptk_name"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.pptk_name !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                    </v-form>
                  </ValidationObserver>

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn
                v-if="user.role === 'admin' ? true : is_editable === '1' ? true : false"
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                color="#4B4B4B"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center"
                style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                <v-icon
                  size="20">
                  mdi-checkbox-marked-circle-outline
                </v-icon>

                <span
                  class="ml-2">
                  Simpan
                </span>
              </v-btn>
              
              <v-btn
                :to="$route.query.from === 'table' ? '/program' : `/program/detail/${$route.params.id}`"
                :disabled="process.form"
                color="red"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center ml-4"
                style="border-radius: 10px; font-weight: 600;">
                <v-icon 
                  size="20">
                  mdi-progress-close
                </v-icon>

                <span
                  class="ml-2">
                  Batal
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
import { readonly } from "vue";
  export default {
    data () {
      return {
        menu: ['Program', 'Kegiatan', 'Sub Kegiatan'],

        list: {
          program: [],
          kegiatan: []
        },

        dialog: {
          snackbar: false,
        },

        show_anggaran: true,
        show_fisik: true,
        select_program: false,

        add_status_dpa: false,

        form: {
          id: '',

          // Field Bantu
          program_id: '',
          kegiatan_id: '',

          par_id: 0,
          par_name: '',
          code: '',
          title: '',
          type: 'Program',
          type_index: 0,

          anggaran_before: 0,
          anggaran: 0,
          anggaran_perubahan: 0,
          
          tahun_anggaran: Number(moment().format('YYYY')),
          tahun_anggaran_text: '',

          target_keu_1: 0,
          target_keu_2: 0,
          target_keu_3: 0,
          target_keu_4: 0,
          target_keu_5: 0,
          target_keu_6: 0,
          target_keu_7: 0,
          target_keu_8: 0,
          target_keu_9: 0,
          target_keu_10: 0,
          target_keu_11: 0,
          target_keu_12: 0,

          target_fisik_1: 0,
          target_fisik_2: 0,
          target_fisik_3: 0,
          target_fisik_4: 0,
          target_fisik_5: 0,
          target_fisik_6: 0,
          target_fisik_7: 0,
          target_fisik_8: 0,
          target_fisik_9: 0,
          target_fisik_10: 0,
          target_fisik_11: 0,
          target_fisik_12: 0,

          realisasi_keu_1: 0,
          realisasi_keu_2: 0,
          realisasi_keu_3: 0,
          realisasi_keu_4: 0,
          realisasi_keu_5: 0,
          realisasi_keu_6: 0,
          realisasi_keu_7: 0,
          realisasi_keu_8: 0,
          realisasi_keu_9: 0,
          realisasi_keu_10: 0,
          realisasi_keu_11: 0,
          realisasi_keu_12: 0,

          realisasi_fisik_1: 0,
          realisasi_fisik_2: 0,
          realisasi_fisik_3: 0,
          realisasi_fisik_4: 0,
          realisasi_fisik_5: 0,
          realisasi_fisik_6: 0,
          realisasi_fisik_7: 0,
          realisasi_fisik_8: 0,
          realisasi_fisik_9: 0,
          realisasi_fisik_10: 0,
          realisasi_fisik_11: 0,
          realisasi_fisik_12: 0,

          ppkom_name: '',
          pptk_name: '',

          is_excluded: 'tidak'
        },

        process: {
          form: false
        },
        
        message: {
          success: '',
          error: ''
        },
        is_editable: '0'
      }
    },
    components: {
      
    },
    watch: {
      'form.type': function() {
        this.form.anggaran_before = 0
      },

      'form.program_id': function() {
        let t = this

        let p = this.list.program.filter(function(v) {
          return t.form.program_id == v.id
        })

        if (p.length > 0 && this.form.type === 'Kegiatan') {
          this.form.anggaran_before = p[0].anggaran

          this.form.code = `${p[0].code}.`
        }
      },

      'form.kegiatan_id': function() {
        let t = this

        let k = this.list.kegiatan.filter(function(v) {
          return t.form.kegiatan_id == v.id
        })
        
        if (k.length > 0 && this.form.type === 'Sub Kegiatan') {
          this.form.anggaran_before = k[0].anggaran

          this.form.code = `${k[0].code}.`
        }
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      years () {
        let max = new Date('10-01-2024').getFullYear()+6, min = max - 6, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        let params = {
          id: this.$route.params.id,
          dpa_status: 'murni'
        }

        await get('admin/task/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            let data = res.results.data

            this.is_editable = data.is_editable

            this.form = {
              id: data.id,

              // Field Bantu
              program_id: data.type === 'Program' ? '' : data.type === 'Kegiatan' ? data.par_id : this.cek_idProgram(data.par_id),
              kegiatan_id: data.type === 'Sub Kegiatan' ? data.par_id : '',

              par_id: data.par_id,
              par_name: '',
              code: data.code,
              title: data.title,
              type: data.type,
              type_index: this.menu.findIndex(v => v === data.type),

              anggaran_before: 0,
              anggaran: parseInt(data.anggaran),
              anggaran_perubahan: parseInt(data.anggaran_perubahan),
          
              tahun_anggaran: Number(data.tahun_anggaran),
              tahun_anggaran_text: data.tahun_anggaran_text,

              target_keu_1: Number(data.target_keu_1),
              target_keu_2: Number(data.target_keu_2),
              target_keu_3: Number(data.target_keu_3),
              target_keu_4: Number(data.target_keu_4),
              target_keu_5: Number(data.target_keu_5),
              target_keu_6: Number(data.target_keu_6),
              target_keu_7: Number(data.target_keu_7),
              target_keu_8: Number(data.target_keu_8),
              target_keu_9: Number(data.target_keu_9),
              target_keu_10: Number(data.target_keu_10),
              target_keu_11: Number(data.target_keu_11),
              target_keu_12: Number(data.target_keu_12),

              target_fisik_1: Number(data.target_fisik_1),
              target_fisik_2: Number(data.target_fisik_2),
              target_fisik_3: Number(data.target_fisik_3),
              target_fisik_4: Number(data.target_fisik_4),
              target_fisik_5: Number(data.target_fisik_5),
              target_fisik_6: Number(data.target_fisik_6),
              target_fisik_7: Number(data.target_fisik_7),
              target_fisik_8: Number(data.target_fisik_8),
              target_fisik_9: Number(data.target_fisik_9),
              target_fisik_10: Number(data.target_fisik_10),
              target_fisik_11: Number(data.target_fisik_11),
              target_fisik_12: Number(data.target_fisik_12),

              realisasi_keu_1: Number(data.realisasi_keu_1),
              realisasi_keu_2: Number(data.realisasi_keu_2),
              realisasi_keu_3: Number(data.realisasi_keu_3),
              realisasi_keu_4: Number(data.realisasi_keu_4),
              realisasi_keu_5: Number(data.realisasi_keu_5),
              realisasi_keu_6: Number(data.realisasi_keu_6),
              realisasi_keu_7: Number(data.realisasi_keu_7),
              realisasi_keu_8: Number(data.realisasi_keu_8),
              realisasi_keu_9: Number(data.realisasi_keu_9),
              realisasi_keu_10: Number(data.realisasi_keu_10),
              realisasi_keu_11: Number(data.realisasi_keu_11),
              realisasi_keu_12: Number(data.realisasi_keu_12),

              realisasi_fisik_1: Number(data.realisasi_fisik_1),
              realisasi_fisik_2: Number(data.realisasi_fisik_2),
              realisasi_fisik_3: Number(data.realisasi_fisik_3),
              realisasi_fisik_4: Number(data.realisasi_fisik_4),
              realisasi_fisik_5: Number(data.realisasi_fisik_5),
              realisasi_fisik_6: Number(data.realisasi_fisik_6),
              realisasi_fisik_7: Number(data.realisasi_fisik_7),
              realisasi_fisik_8: Number(data.realisasi_fisik_8),
              realisasi_fisik_9: Number(data.realisasi_fisik_9),
              realisasi_fisik_10: Number(data.realisasi_fisik_10),
              realisasi_fisik_11: Number(data.realisasi_fisik_11),
              realisasi_fisik_12: Number(data.realisasi_fisik_12),

              ppkom_name: data.ppkom_name,
              pptk_name: data.pptk_name,

              is_excluded: data.is_excluded
            }

            this.fetchProgram()

            // console.log(this.form.anggaran)
          }
        })
      },
      
      async fetchProgram () {
        let params = {
          limit: 100000,
          type: 'Program',

          unit_id: this.$route.query.unit_id,
          tahun_anggaran: this.form.tahun_anggaran
        }

        await get('admin/task/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.list.program = res.results.data

            let t = this

            let p = this.list.program.filter(function(v) {
              return t.form.program_id == v.id
            })

            if (p.length > 0 && this.form.type === 'Kegiatan') {
              this.form.anggaran_before = p[0].anggaran
            }
          }
        })
      },

      async fetchKegiatan () {
        let params = {
          limit: 100000,
          par_id: this.form.program_id,

          unit_id: this.$route.query.unit_id,
          tahun_anggaran: this.form.tahun_anggaran
        }

        await get('admin/task/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.list.kegiatan = res.results.data

            let t = this

            let k = this.list.kegiatan.filter(function(v) {
              return t.form.kegiatan_id == v.id
            })
            
            if (k.length > 0 && this.form.type === 'Sub Kegiatan') {
              this.form.anggaran_before = k[0].anggaran
            }
          }
        })
      },

      async cek_idProgram (id) {
        let params = {
          id: id,

          unit_id: this.$route.query.unit_id,
          tahun_anggaran: this.form.tahun_anggaran
        }

        await get('admin/task/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            let data = res.results.data.length > 0 ? res.results.data[0] : ''
            
            this.form.program_id = data.par_id

            this.fetchKegiatan()
          }
        })
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          this.form.par_id = this.form.type === 'Program' ? 0 : this.form.type === 'Kegiatan' ? this.form.program_id : this.form.kegiatan_id

          // SAVE TO REST API
          await post(`admin/task/update`, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.message.success = res.message
              this.dialog.snackbar = true

              setTimeout(() => {
                let url_back = this.$route.query.from === 'table' ? '/program' : `/program/detail/${this.$route.params.id}`

                this.$router.push({ path: url_back })
              }, 850)

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>